// extracted by mini-css-extract-plugin
module.exports = {"container":"Winner_container__1H3xA","name":"Winner_name__2EhtN"};